import { Form, FormInstance, Layout } from 'antd';
import { useMemo, useState } from 'react';
import { FormContent } from './FormContent';
import { FormHeader } from './FormHeader';
import { FormSider } from './FormSider';
import {
  subEmotionalDisordersSubLevel,
  supDisabilityDevelopment,
  supDisabilityHearing,
  supDisabilityIntelect,
  supDisabilityMovement,
  supDisabilitySight,
  supDisabilityTypes,
  supDisorderActivityAndAttentionSubLevel,
  supDisorderBehaviouralEmotional,
  supDisorderBehaviouralSubLevel,
  supDisorderLearningDisability,
  supDisorderSpeech,
  supDisorderTypes,
  supGroups,
  supLanguageDisordersSubLevel,
  supLearningDifficultyTypes,
  supLearningDisorderSubLevel,
  supSpeechDisordersSubLevel,
} from './constants/sup';
const supTypes = [
  supDisabilityTypes,
  supDisorderTypes,
  supLearningDifficultyTypes,
];

const disabilitySelectionsMap = {
  [supDisabilityTypes[0]]: supDisabilityIntelect,
  [supDisabilityTypes[1]]: supDisabilitySight,
  [supDisabilityTypes[2]]: supDisabilityHearing,
  [supDisabilityTypes[4]]: supDisabilityMovement,
  [supDisabilityTypes[5]]: supDisabilityDevelopment,
};

const disorderSelectionsMap = {
  [supDisorderTypes[0]]: supDisorderLearningDisability,
  [supDisorderTypes[1]]: supDisorderBehaviouralEmotional,
  [supDisorderTypes[2]]: supDisorderSpeech,
};

const subDisorderSelectionsMap = {
  [supDisorderLearningDisability[1]]: supLearningDisorderSubLevel,
  [supDisorderBehaviouralEmotional[0]]: supDisorderActivityAndAttentionSubLevel,
  [supDisorderBehaviouralEmotional[1]]: supDisorderBehaviouralSubLevel,
  [supDisorderBehaviouralEmotional[2]]: subEmotionalDisordersSubLevel,
  [supDisorderSpeech[0]]: supSpeechDisordersSubLevel,
  [supDisorderSpeech[1]]: supLanguageDisordersSubLevel,
};

const deps1 = [['registration', 'supSubSpecific']];
const deps2 = [deps1[0], ['registration', 'supSpecific']];
const deps3 = [deps1[0], deps2[1], ['registration', 'supSubGroup']];

export const getOnValuesChange =
  (
    setSpecNeedsSubGroupOptions: any,
    setSpecNeedsSpecificOptions: any,
    setSpecNeedsSubSpecificOptions: any,
  ) =>
  (changedValues: any, form: FormInstance) => {
    if (changedValues.registration) {
      const registration = changedValues.registration;
      if (registration.supGroup) {
        form.resetFields(deps3);
        const options =
          supTypes[supGroups.indexOf(registration.supGroup)] || [];
        setSpecNeedsSubGroupOptions(options);
        setSpecNeedsSpecificOptions([]);
        setSpecNeedsSubSpecificOptions([]);
      }
      if (registration.supSubGroup) {
        form.resetFields(deps2);
        setSpecNeedsSpecificOptions(
          disabilitySelectionsMap[registration.supSubGroup] ||
            disorderSelectionsMap[registration.supSubGroup] ||
            [],
        );
        setSpecNeedsSubSpecificOptions([]);
        form.setFieldValue(
          ['registration', 'supSubGroup'],
          registration.supSubGroup,
        );
      }
      if (registration.supSpecific) {
        form.resetFields(deps1);
        setSpecNeedsSubSpecificOptions(
          subDisorderSelectionsMap[registration.supSpecific] || [],
        );
        form.setFieldValue(
          ['registration', 'supSpecific'],
          registration.supSpecific,
        );
      }
      if (registration.supSubSpecific) {
        form.setFieldValue(
          ['registration', 'supSubSpecific'],
          registration.supSubSpecific,
        );
      }
    }
  };

export const PageLayout = () => {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);

  const [specNeedsSubGroupOptions, setSpecNeedsSubGroupOptions] = useState<
    string[]
  >([]);
  const [specNeedsSpecificOptions, setSpecNeedsSpecificOptions] = useState<
    string[]
  >([]);
  const [specNeedsSubSpecificOptions, setSpecNeedsSubSpecificOptions] =
    useState<string[]>([]);

  const onValuesChange = useMemo(
    () =>
      getOnValuesChange(
        setSpecNeedsSubGroupOptions,
        setSpecNeedsSpecificOptions,
        setSpecNeedsSubSpecificOptions,
      ),
    [],
  );

  return (
    <Layout style={{ maxWidth: 1024, margin: '0 auto' }}>
      <Layout.Header>
        <FormHeader
          form={form}
          setCurrentStep={setCurrentStep}
          onValuesChange={onValuesChange}
        />
      </Layout.Header>
      <Layout>
        <Layout.Sider width="20%">
          <FormSider form={form} step={currentStep} setStep={setCurrentStep} />
        </Layout.Sider>
        <Layout.Content>
          <FormContent
            specNeedsSubGroupOptions={specNeedsSubGroupOptions}
            specNeedsSpecificOptions={specNeedsSpecificOptions}
            specNeedsSubSpecificOptions={specNeedsSubSpecificOptions}
            onValuesChange={onValuesChange}
            form={form}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        </Layout.Content>
      </Layout>
    </Layout>
  );
};
